/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { TestAiCredentialMutationResponse, TestAiCredentialPathParams, TestAiCredential400, TestAiCredential401, TestAiCredential403, TestAiCredential404, TestAiCredential409, TestAiCredential500 } from "../../types/platformBillingController/TestAiCredential.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getTestAiCredentialUrl(organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/platform-billing/credentials/${provider}/test` as const }
  return res
}

/**
 * @summary Test a stored BYOK provider key (boolean-only)
 * {@link /api/organizations/:organizationId/platform-billing/credentials/:provider/test}
 */
export async function testAiCredential(organizationId: TestAiCredentialPathParams["organizationId"], provider: TestAiCredentialPathParams["provider"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<TestAiCredentialMutationResponse, ResponseErrorConfig<TestAiCredential400 | TestAiCredential401 | TestAiCredential403 | TestAiCredential404 | TestAiCredential409 | TestAiCredential500>, unknown>({ method : "POST", url : getTestAiCredentialUrl(organizationId, provider).url.toString(), ... requestConfig })
  return res.data
}